var render = function render(){var _vm=this,_c=_vm._self._c;return _c('main',{staticClass:"py-2 max-w-7xl mx-auto sm:px-6 lg:px-8"},[(_vm.isCandidate)?_c('div',[(_vm.isCandidate)?_c('user-files'):_vm._e()],1):_vm._e(),_c('documents',{staticClass:"mt-4"})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }